import type MainMenuServiceProvider from '../components/main-menu/main-menu.provider';

/*@ngInject*/
export default function mainMenuConfig(mainMenuServiceProvider: MainMenuServiceProvider) {

    /*@ngInject*/
    const isLoggedFunction = (currentAuth) => currentAuth.evided;

    /*@ngInject*/
    const onRequireAuthClickFunction = (loginService) => loginService.thisPageLogged();

    mainMenuServiceProvider.setIsLoggedFunction(isLoggedFunction);

    mainMenuServiceProvider.setOnRequireAuthClick(onRequireAuthClickFunction);
}
